import { useAppSelector } from "@/config/store";
import { IEdoChatParticipation } from "@/shared/model/edo-chat-participation.model";
import { EdoChatType } from "@/shared/model/enumerations/edo-chat-type.model";
import { ChatState } from "@/shared/reducers/chat.reducer";
import {
  Avatar,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@/components/ui";
import axios from "axios";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const Info = () => {
  const params = useParams<{ id: string }>();
  const [participations, setParticipations] = useState<IEdoChatParticipation[]>(
    []
  );
  const { selectedParticipation } = useAppSelector<ChatState>(
    (state) => state.chat
  );

  useEffect(() => {
    const getAllParticipations = async () => {
      const response = await axios.get("/chat-participations", {
        params: {
          page: 0,
          limit: 20,
          sortBy: "createdAt:ASC",
          "filter.chat.id": "$eq:" + params.id,
        },
      });
      setParticipations(response.data.data);
    };
    if (params.id) getAllParticipations();
  }, [params.id]);

  return (
    <div className="flex h-full flex-col">
      <div>
        {selectedParticipation?.chat && (
          <List className="divide-y divide-[var(--color-mockup-border)]">
            <ListItem className="flex items-center gap-3 py-3">
              <ListItemIcon>
                <Avatar
                  fallback={
                    selectedParticipation.chat.type === EdoChatType.CHAT
                      ? (selectedParticipation.title ?? "?")[0]
                      : (selectedParticipation.chat.title ?? "?")[0]
                  }
                />
              </ListItemIcon>
              <ListItemText
                primary={
                  selectedParticipation.chat.type === EdoChatType.CHAT
                    ? selectedParticipation.title
                    : selectedParticipation.chat.title
                }
              />
            </ListItem>
          </List>
        )}
      </div>
      <div className="border-t border-[var(--color-mockup-border)]" />
      <div className="min-h-0 flex-1 overflow-auto">
        <List className="divide-y divide-[var(--color-mockup-border)]">
          <li className="sticky top-0 z-10 bg-[var(--color-surface-secondary)] px-4 py-2 text-sm font-medium text-[var(--color-mockup-text-mid)] dark:bg-[var(--color-surface-secondary)] dark:text-[var(--color-mockup-text-light)]">
            Membri della chat
          </li>
          {participations.map((participation, index) => (
            <ListItem key={participation.id ?? index} className="flex items-center gap-3 py-3">
              <Avatar
                fallback={
                  participation.user.firstName[0] + participation.user.lastName[0]
                }
              />
              <ListItemText
                primary={
                  participation.user.firstName +
                  " " +
                  participation.user.lastName
                }
              />
            </ListItem>
          ))}
        </List>
      </div>
    </div>
  );
};

export default Info;
